module.exports = __webpack_public_path__ + "static/media/fable.a8fd2569.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/fable.png
// module id = 146
// module chunks = 0